import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { UsuarioRol } from 'src/app/models/entities/usuario-rol';
import { database } from 'firebase';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UsuarioRolService {

  public path: string;
  public constructor(public angularFireDatabase: AngularFireDatabase) {
    this.path = "usuariosRoles";
  }
  public save(usuarioRol: UsuarioRol): Promise<any> {
    let { keyUsuario, keyRol } = usuarioRol;
    return this.angularFireDatabase.object<UsuarioRol>(`${this.path}/${keyUsuario}_${keyRol}`).set(usuarioRol);
  }

  public findByKeyUsuario(keyUsuario: string): Observable<UsuarioRol> {
    return this.angularFireDatabase.list<UsuarioRol>(
      this.path,
      (ref: database.Reference) => ref.orderByChild('keyUsuario').equalTo(keyUsuario)
    ).snapshotChanges()
      .pipe(
        map(
          changes =>
            changes.map(c => (
              ({
                key: c.payload.key,
                ...c.payload.val()
              } as UsuarioRol)
            ))
        ),
        map((usuarioRol: UsuarioRol[]) => usuarioRol[0])
      );
  }

  public deleteUsuario(key: string, rolUsuario: string) {
    return this.angularFireDatabase.list<UsuarioRol>(this.path).remove(`${key}_${rolUsuario}`)
  }

}
